import { Injectable } from '@angular/core';
import _ from 'lodash';
import { BehaviorSubject, filter, switchMap, tap } from 'rxjs';
import { FiltersService } from '../components/filters/services/filters.service';
import { MeUser } from '../models/me-user';
import { MenuItem } from '../models/menu-item';
import { AuthenticationService } from './authentication.service';
import { LanguageService, LanguageSettings } from './language.service';
import { LoaderService } from './loader.service';
import { NavigationService } from './navigation/navigation.service';
import { IPayload, Payload } from './payload/models/payload';
import { DialogService } from './dialog/dialog.service';
import { InfoDialogData } from './dialog/dialog-models';
import { MatDialogRef } from '@angular/material/dialog';
import { InfoDialogComponent } from './dialog/components/info-dialog/info-dialog.component';
import { NotificationsComponent } from '../components/notifications/notifications.component';
import { Notification as CsiNotification } from './dialog/notification-models';


@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  user: BehaviorSubject<MeUser>;
  languageState: BehaviorSubject<LanguageSettings>;
  availableSteps: BehaviorSubject<MenuItem[]>;
  selectedStep: BehaviorSubject<MenuItem | null>;
  selectedPage: BehaviorSubject<MenuItem | null>;
  payload: BehaviorSubject<IPayload>;
  demoSubject = new BehaviorSubject<boolean>(true);
  salesSubject = new BehaviorSubject<boolean>(true);
  afterSalesSubject = new BehaviorSubject<boolean>(true);
  productSubject = new BehaviorSubject<boolean>(true);

  get dictionary(): Record<string, string> {
    return this.languageState.value.data ?? {};
  }

  constructor(
    private authService: AuthenticationService,
    private languageService: LanguageService,
    private loaderService: LoaderService,
    private navigationService: NavigationService,
    private filtersService: FiltersService,
    private dialogService: DialogService,
  ) {
    this.user = this.authService._userSubject;
    this.languageState = this.languageService._languageStateSubject;
    this.availableSteps = this.navigationService._availableStepsSubject;
    this.selectedStep = this.navigationService._selectedStepSubject;
    this.selectedPage = this.navigationService._selectedPageSubject;
    this.payload = this.filtersService.appliedFilters;
    this.setLanguage('en-GB');
  }

  startNavBarMenu(user: MeUser) {
    this.navigationService.startNavbarMenu(user);
  }

  resetUser() {
    this.authService.resetUser();
  }

  //LANGUAGE
  setLanguage(language: string) {
    this.languageService.setLanguage(language);
  }

  getCurrentLanguage(): string {
    return this.languageService.currentLanguage;
  }

  translate(key: string, parentKey?: string): string {
    // return '';
    const path = parentKey ? [parentKey, key].concat('.') : key;
    return _.get(this.dictionary, path) ?? key;
  }

  //LOADER
  startLoader() {
    this.loaderService.startLoader();
  }

  stopLoader() {
    this.loaderService.stopLoader();
  }

  //NAVIGATION
  selectStep(step: MenuItem) {
    this.navigationService.selectStep(step);
  }

  deselectStep() {
    this.navigationService.deselectStep();
  }

  selectPage(item: MenuItem) {
    this.navigationService.selectPage(item);
  }

  navigateToLandingPage(scope: string) {
    this.navigationService.navigateToLandingPage(scope);
  }

  //PAYLOAD

  clearFilters() {
    this.filtersService.clearFilters();
  }

  //DIALOG
  openInfoDialog(info: InfoDialogData): MatDialogRef<InfoDialogComponent> {
    return this.dialogService.openInfoDialog(info);
  }

  openNotificationsDialog(info: CsiNotification[]): MatDialogRef<NotificationsComponent> {
    return this.dialogService.openNotificationsDialog(info);
  }

}
